/** @format */

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
//import { Resource } from '../resources/types';

export interface SidebarState {
  showSidebar: boolean;
  status: "idle" | "loading" | "failed";
}

const initialState: SidebarState = {
  showSidebar: true,
  status: "idle",
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setShowSidebar: (state, action: PayloadAction<boolean>) => {
      state.showSidebar = action.payload;
    },
  },
});

export const { setShowSidebar } = sidebarSlice.actions;
export const selectShowSidebar = () => (state: RootState) =>
  state.sidebar.showSidebar;

export default sidebarSlice.reducer;
